/**
 * 腾讯域：红线规则配置 API 服务（CLAUDE.md §前端 API 服务层 — 按域分目录）。
 *
 * 与后端 Pydantic 模型 src.tencent.dtos.redline_config 对齐。
 *   - GET  /api/v1/tencent/redline-config        → 全表读
 *   - PUT  /api/v1/tencent/redline-config        → 保存（upsert 一批行）
 *   - POST /api/v1/tencent/redline-config/seed   → 空表种入 8 行默认
 */

import { request } from "../apiClient";

/** 红线规则配置行（与后端 RedlineConfigItem 对齐）。 */
export interface RedlineConfigItem {
  targeting_type: string;
  targeting_id: string;
  targeting_name: string;
  ext_info?: string | null;
}

/** 红线规则配置行（含审计列，与后端 RedlineConfigRecord 对齐）。 */
export interface RedlineConfigRecord extends RedlineConfigItem {
  create_user?: string | null;
  modify_user?: string | null;
  created_time?: string | null;
  updated_time?: string | null;
}

export interface SaveRedlineConfigBody {
  rows: RedlineConfigItem[];
}

/** 获取全部红线规则配置（按 targeting_type 排序）。 */
export async function getRedlineConfig(): Promise<RedlineConfigRecord[]> {
  const data = await request<RedlineConfigRecord[] | null>(
    "/api/v1/tencent/redline-config",
  );
  return data ?? [];
}

/** 保存（upsert）一批红线配置行；返回保存后全表（含更新后的审计列）。 */
export async function saveRedlineConfig(
  body: SaveRedlineConfigBody,
): Promise<RedlineConfigRecord[]> {
  const data = await request<RedlineConfigRecord[] | null>(
    "/api/v1/tencent/redline-config",
    { method: "PUT", body },
  );
  return data ?? [];
}

/** 空表时种入 8 行默认红线配置；返回本次种入行数（非空表返回 0）。 */
export async function seedRedlineConfig(): Promise<number> {
  const data = await request<{ seeded: number } | null>(
    "/api/v1/tencent/redline-config/seed",
    { method: "POST" },
  );
  return data?.seeded ?? 0;
}
